module.exports = __webpack_public_path__ + "assets/img/right-title-open-c2c26af7.png";